import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const LanguageSwitcher = ({ variant = "light" }) => {
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = langs.find((l) => l.code === lang) || langs[0];
  const isDark = variant === "dark";

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        data-testid="language-switcher"
        onClick={() => setOpen((o) => !o)}
        aria-label="Choisir la langue"
        className={`h-10 px-3 sm:px-4 rounded-full flex items-center gap-2 text-xs font-medium tracking-wider uppercase transition-all ${
          isDark
            ? "bg-white/10 hover:bg-white/20 text-[color:var(--color-bg)] border border-white/20"
            : "hover:bg-white/60 text-[color:var(--color-dark)]"
        }`}
      >
        <Globe size={14} strokeWidth={2} />
        <span>{current.flag}</span>
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-3 w-56 rounded-2xl glass-light overflow-hidden shadow-[0_20px_50px_rgba(44,30,22,0.18)] z-50"
        >
          <div className="p-1.5">
            {langs.map((l) => (
              <button
                key={l.code}
                type="button"
                data-testid={`lang-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl text-sm transition ${
                  l.code === lang
                    ? "bg-[color:var(--color-dark)] text-[color:var(--color-bg)]"
                    : "text-[color:var(--color-dark)] hover:bg-white/60"
                }`}
              >
                <span className="flex items-center gap-3">
                  <span className="text-[11px] tracking-[0.2em] opacity-70 w-7">
                    {l.flag}
                  </span>
                  <span>{l.label}</span>
                </span>
                {l.code === lang && <Check size={14} />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
